module.exports = __webpack_public_path__ + "static/media/extend_voting_deadline.d52cb2d5.svg";